






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// import { Action, namespace } from "vuex-class";

@Component
export default class SearchHeader extends Vue {
  @Prop({ default: "ConfirmedConsent" }) title!: string;

  toggleSideMenu(item: any) {
    this.$root.$emit("toggleSideMenu");
  }
}
